import { deviceTokensApi } from '../api/modules/deviceTokens.api';
import { getApiErrorMessage } from '../api/client';
import {
  clearStoredFcmToken,
  enableWebPush,
  getNotificationPermission,
  getStoredFcmToken,
  isFirebaseMessagingConfigured,
  listenForForegroundMessages,
} from '../services/firebaseMessaging';

export async function getPushStatus() {
  const configured = await isFirebaseMessagingConfigured();
  return {
    configured,
    permission: getNotificationPermission(),
    hasLocalToken: Boolean(getStoredFcmToken()),
  };
}

/**
 * Enable browser notifications and register the FCM token with the backend.
 */
export async function enableAndRegisterWebPush() {
  try {
    const token = await enableWebPush();
    await deviceTokensApi.register({
      token,
      platform: 'web',
      deviceId: 'admin-web',
    });
    return { token };
  } catch (error) {
    throw new Error(getApiErrorMessage(error, error?.message || 'Failed to enable push'));
  }
}

export async function unregisterWebPushBestEffort() {
  const token = getStoredFcmToken();
  if (!token) return;
  try {
    await deviceTokensApi.unregister(token);
  } catch {
    // ignore
  } finally {
    clearStoredFcmToken();
  }
}

export async function sendTestNotification(payload = {}) {
  try {
    return await deviceTokensApi.sendTest(payload);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to send test notification'));
  }
}

export { listenForForegroundMessages };
